
















import { Component, Mixins } from "vue-property-decorator";
import { Color, TextureKinds, PaintStyle, ScreenDirection } from "../../../../domain/drawing";
import { IValueRange, ValueRange } from "../../../../domain/system";
import { TextBoxItem, BarItem } from "../../../../domain/document/items";
import { BarInput } from "../../../drawing";
import { SourceEditableObjectMixin } from "./mixins";

@Component({
  components: {
    BarInput
  }
})
export default class BarObject extends Mixins(SourceEditableObjectMixin) {
  readPropertyOrDefault: <T>(reader: (s: BarItem) => T, defaultValue: T) => T;
  readSourcePropertyOrDefault: <T>(reader: (s: TextBoxItem) => T, defaultValue: T) => T;
  writeSourcePropertyWhenValid: (write: (s: TextBoxItem) => void) => void;

  get valueAsNumber(): number {
    return this.readSourcePropertyOrDefault(s => parseFloat(s.value), NaN);
  }

  set valueAsNumber(source: number) {
    this.writeSourcePropertyWhenValid(s => s.value = source.toString());
  }

  get range(): IValueRange {
    return this.readPropertyOrDefault(s => s.range, new ValueRange(0, 100));
  }

  get stepCount(): number {
    return this.readPropertyOrDefault(s => s.stepCount, 1);
  }

  get direction(): ScreenDirection {
    return this.readPropertyOrDefault(s => s.direction, "top");
  }

  get defaultPaintStyle(): PaintStyle {
    return new PaintStyle(new Color("transparent"), TextureKinds.None);
  }

  get paintStyle(): PaintStyle {
    return this.readPropertyOrDefault(s => s.paintStyle ? s.paintStyle : this.defaultPaintStyle, this.defaultPaintStyle);
  }

  get isEditable(): boolean {
    return this.readSourcePropertyOrDefault(s => s.isFreeInputable, false);
  }

  get knobSize(): number {
    return Math.min(this.width, this.height);
  }
}
